import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1696522a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "types" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Broad")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Phrase ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Exact ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_list_table = _resolveComponent("list-table")!

  return (_openBlock(), _createBlock(_component_list_table, {
    header: _ctx.groupHeader,
    items: _ctx.keywords,
    loading: _ctx.loading,
    "is-loaded": _ctx.isLoaded,
    onLoadMore: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('loadMore')))
  }, {
    "body-row": _withCtx(({ item }) => [
      _createElementVNode("td", {
        class: _normalizeClass([{ active: _ctx.isActive(item.id) }, "name"])
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_checkbox, {
            id: item.id,
            value: _ctx.selectedKeywords,
            "onUpdate:modelValue": ($event: any) => (_ctx.$emit('setSelectedKeyword', item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["id", "value", "onUpdate:modelValue"])
        ])
      ], 2),
      _createElementVNode("td", {
        class: _normalizeClass({ active: _ctx.isActive(item.id) })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_checkbox, {
            modelValue: item.broad,
            "onUpdate:modelValue": [($event: any) => ((item.broad) = $event), ($event: any) => (_ctx.changeMatchTypes(item))],
            class: "types-item",
            type: "checkbox",
            value: item.broad,
            "true-value": true,
            "false-value": false
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "value"]),
          _createVNode(_component_checkbox, {
            modelValue: item.phrase,
            "onUpdate:modelValue": [($event: any) => ((item.phrase) = $event), ($event: any) => (_ctx.changeMatchTypes(item))],
            class: "types-item",
            type: "checkbox",
            value: item.phrase,
            "true-value": true,
            "false-value": false
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "value"]),
          _createVNode(_component_checkbox, {
            modelValue: item.exact,
            "onUpdate:modelValue": [($event: any) => ((item.exact) = $event), ($event: any) => (_ctx.changeMatchTypes(item))],
            class: "types-item",
            type: "checkbox",
            value: item.exact,
            "true-value": true,
            "false-value": false
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["header", "items", "loading", "is-loaded"]))
}